<template  >

    <spinner v-if="!loaded" ></spinner>

    <div class="template-page" v-else-if="loaded" >
        <div class="col-12 col-md-8 offset-md-2 mt-5" >

            <div class="col-12" v-if="currentStep == 0" >
                
                <b-form  class="atlass-form col-12 mb-5" >

                    <div class="row no-gutters"  >

                        <div class="col-12 form-group" >
                            <label> FIRSTNAME: </label>
                            <b-form-input 
                            type="text"
                            v-model="data.billingInfo.firstname"
                            required
                            class="form-control"
                            placeholder="Firstname">
                            </b-form-input>
                        </div>

                        <div class="col-12 form-group" >
                            <label> LASTNAME: </label>
                            <b-form-input 
                            type="text"
                            v-model="data.billingInfo.lastname"
                            required
                            class="form-control"
                            placeholder="Lastname">
                            </b-form-input>
                        </div>

                        <div class="col-12 form-group" >
                            <label> COMPANY NAME: </label>
                            <b-form-input 
                            type="text"
                            v-model="data.billingInfo.company"
                            required
                            class="form-control"
                            placeholder="Company name">
                            </b-form-input>
                        </div>

                        <div class="col-12 form-group" >
                            <label> Full Address: </label>
                            <b-form-input 
                            type="text"
                            v-model="data.billingInfo.address"
                            required
                            class="form-control"
                            placeholder="Address, number ">
                            </b-form-input>
                        </div>

                        <div class="col-12 form-group" >
                            <label> ZIP CODE: </label>
                            <b-form-input 
                            type="text"
                            v-model="data.billingInfo.zip_code"
                            required
                            class="form-control"
                            placeholder="ZIP Code">
                            </b-form-input>
                        </div>

                        <div class="col-12 form-group" >
                            <label> City: </label>
                            <b-form-input 
                            type="text"
                            v-model="data.billingInfo.city"
                            required
                            class="form-control"
                            placeholder="City">
                            </b-form-input>
                        </div>

                        <div class="col-12 form-group" >
                            <label> Country: </label>
                            <b-form-input 
                            type="text"
                            v-model="data.billingInfo.country"
                            required
                            class="form-control"
                            placeholder="Country">
                            </b-form-input>
                        </div>

                        <div class="col-12 form-group" >
                            <label> VAT NUMBER: </label>
                            <b-form-input 
                            type="text"
                            v-model="data.billingInfo.vat_number"
                            required
                            class="form-control"
                            placeholder="VAT Number">
                            </b-form-input>
                        </div>

                    </div>
                </b-form>
                
            </div> <!-- step 0 -->
            
            <div class="col-12" v-if="currentStep == 1" >
                
                <b-form  class="atlass-form col-12 mb-5" >

                    <div class="row no-gutters mt-5"  >

                        <div class="col-12 form-group" >
                            <label> CARD NUMBER: </label>
                            <b-form-input 
                            type="text"
                            v-model="data.card.number"
                            required
                            class="form-control"
                            placeholder="XXXX XXXX XXXX XXXX">
                            </b-form-input>
                        </div>

                        <div class="col-12 form-group" >
                            <label> EXPIRY MONTH: </label>
                            <b-form-input 
                            type="text"
                            v-model="data.card.exp_month"
                            required
                            class="form-control"
                            placeholder="XX">
                            </b-form-input>
                        </div>

                        <div class="col-12 form-group" >
                            <label> EXP YEAR: </label>
                            <b-form-input 
                            type="text"
                            v-model="data.card.exp_year"
                            required
                            class="form-control"
                            placeholder="XX">
                            </b-form-input>
                        </div>

                        <div class="col-12 form-group" >
                            <label> CVC NUMBER: </label>
                            <b-form-input 
                            type="text"
                            v-model="data.card.cvc"
                            required
                            class="form-control"
                            placeholder="XXX">
                            </b-form-input>
                        </div>

                    </div>
                </b-form>
                
            </div> <!-- step 1 -->
            
            <div class="col-12" v-if="currentStep == 2" >
                
                <b-form  class="atlass-form col-12 mb-5" >

                    <div class="col-12" >
                        <h2> Choose subscription </h2>
                    </div>
                    
                    <div class="row no-gutters"  >


                    </div>
                    
                </b-form>
                
            </div> <!-- step 1 -->

            <div class="row w-100" >
                <div class="col-6 text-right" >
                    <button @click="if( currentStep > 0 ){currentStep -= 1}" class="btn btn-secondary"  > Previous </button>
                </div>
                <div class="col-6 text-left" >
                    <button @click="currentStep += 1" class="btn btn-primary" v-if="currentStep < maxStep - 1" > Next </button>
                    <button @click="save()" class="btn btn-success" v-if="currentStep == maxStep - 1" > Done </button>
                </div>
            </div>    

        </div> <!-- .col-12 col-md-8 -->
    </div> <!-- .template-page --> 

</template>

<script>
import Cookies from 'js-cookie'
import axios from 'axios'
import { mapGetters, mapState } from 'vuex'
import helper from '@/helpers/helpers.js';
    
export default {
    name: 'User',
    props: {
    },
    data: function(){
        return {
            filter: '',
            loaded: false,
            timeout: 100,
            step: 0,
            maxStep: 4,
            currentStep : 0,
            
            data: {
                card:{
                    number: '',
                    exp_month: '',
                    exp_year: '',
                    cvc: '',
                },
                billingInfo:{
                    firstname: '',
                    lastname: '',
                    company: '',
                    address: '',
                    city: '',
                    country: '',
                    zip_code: '',
                    vat_number: ''
                },
                product: {}
            }
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        
    },
    mounted: function () {
                
        this.loaded = true;
        
    },
    methods: {

        save(){
            console.log(this.data)
        }
        
    },
    computed: {
        
    },
    watch: {

    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  >

    
</style>



// WEBPACK FOOTER //
// src/components/billingSetup.vue